import { Entity } from '@backstage/catalog-model';
import {
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from '@material-ui/core';
import { NOT_APPROVED } from '../../utils/constant';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useMemo, useState } from 'react';
import { useEntityList, EntityFilter } from '@backstage/plugin-catalog-react';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

class EntityLifecycleFilter implements EntityFilter {
  constructor(readonly values: string[]) {}

  filterEntity(entity: Entity): boolean {
    return this.values.some(v =>
      (entity.metadata.apiservice ?? []).includes(v),
    );
  }

  toQueryValue(): string[] {
    return this.values;
  }
}

export const ApiEntityServicePicker = () => {
  const { updateFilters, backendEntities, filters, queryParameters } =
    useEntityList();

  const queryParamApiService = [queryParameters.apiservice]
    .flat()
    .filter(Boolean) as string[];
  const [selectedApiService, setSelectedApiService] = useState(
    queryParamApiService.length
      ? queryParamApiService
      : filters.apiservice?.values ?? [],
  );

  useEffect(() => {
    updateFilters({
      apiservice: selectedApiService.length
        ? new EntityLifecycleFilter(selectedApiService)
        : undefined,
    });
  }, [selectedApiService]);

  const availableApiService = useMemo(
    () =>
      [
        ...new Set(
          backendEntities
            .filter(
              (e: any) =>
                e?.metadata?.devxstate?.toLowerCase() !==
                NOT_APPROVED.toLowerCase(),
            )
            .flatMap((e: Entity) => e.metadata?.apiservice)
            .filter(Boolean) as string[],
        ),
      ].sort((a, b) => a.localeCompare(b)),
    [backendEntities],
  );

  if (!availableApiService.length) return null;

  return (
    <Box pb={1} pt={1}>
      <Typography variant="button">Api Group</Typography>
      <Autocomplete
        aria-label="Lifecycle"
        multiple
        options={availableApiService}
        value={selectedApiService}
        onChange={(_: object, value: string[]) => setSelectedApiService(value)}
        renderOption={(option, { selected }) => (
          <FormControlLabel
            control={
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={selected}
              />
            }
            label={option}
          />
        )}
        size="small"
        popupIcon={<ExpandMoreIcon data-testid="tag-picker-expand" />}
        renderInput={params => <TextField {...params} variant="outlined" />}
      />
    </Box>
  );
};
